module.exports = __webpack_public_path__ + "img/background-connections.f83628b9.png";